<template>
  <v-app id="inspire" style="background: transparent">
    <v-app-bar class="overflow-hidden" elevation="0" style="position: sticky;  background: linear-gradient(180deg, rgba(10, 231, 193, 0.95) 1.56%, rgba(18, 138, 250, 0.95) 84.37%); width: 100%">
      <v-row class="container" style="display: flex; justify-content: center; align-items: center">
        <v-layout row wrap>
          <v-flex style="width: 30%;overflow:hidden;white-space: nowrap !important;text-overflow: ellipsis;">
            <div v-if="!$user || ($user && !$user.registered)" style="width: 15%;float: left">
              <v-btn class="white--text" text style="background-color: transparent;" @click="goLogin">
                <v-icon class="pointer" color="#FFFFFF">
                  mdi-account-circle-outline
                </v-icon>
                <span v-if="!$user" style="margin-bottom: 5px">{{ $t('LOGIN') }}</span>
              </v-btn>
            </div>
            <span v-if="($user && !$user.registered)" style="color: white; position: absolute; left: 12.5%; margin-top: 0.7%"> {{ $user.cif }} </span>
            <ProfileAvatar v-if="($user && $user.registered)" class="pointer" style="margin-right: 10px; margin-left: 10px;width: 15%;float: left" />
            <span v-if="($user && $user.registered)" style="color: white; margin-right: 3%;"> {{ $user.name }}</span>
          </v-flex>
          <v-flex style="text-align: center;width: 30% ">
            <img class="pointer" src="/logo-white.png" height="30px" alt="alt" style="" @click="goHome()">
          </v-flex>
          <v-flex style="width: 30%">
            <v-row>
              <div style="width: 80%;text-align: right" class="pointer" @click="goNotificationsPage()">
                <notification-bell v-if="notifications>0"
                                   style="margin-right: 3px"
                                   align="right"
                                   :count="notifications"
                                   icon-color="#FFFFFF"
                                   :size="30"
                                   counter-style="round"
                                   counter-padding="0px 15px"

                />
                <v-icon v-else color="#FFFFFF" @click="goNotificationsPage()">
                  mdi-bell
                </v-icon>
              </div>
            </v-row>
          </v-flex>
        </v-layout>
      </v-row>
    </v-app-bar>
    <v-main style="padding: 0;overflow: hidden;position: absolute;top: 56px;bottom: 10%;left: 0;right: 0;" :class="fullscreenClass">
      <router-view :style="{background: $vuetify.theme.themes[theme].background, minHeight: '100%', height: '100%'}" style="background: transparent" />
    </v-main>
    <SnackBar />
    <SplashScreen />
    <UserMissingCif />
    <FactoringLogic />
    <ConfirmationModal />
    <PaymentModal />
    <CameraModal />
    <CollateralModal />
    <amm-modal />
    <InvoicesToMarketModal />
    <notificationOptions />

    <v-dialog v-model="loading" width="450">
      <v-card>
        <v-card-text class="pa-0" style="text-align: justify;">
          <Loading />
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="app-container">
      <v-footer class="footer" color="base" app style=" height:10%; background: linear-gradient(180deg, rgba(10, 231, 193, 0.95) 1.56%, rgba(18, 138, 250, 0.95) 84.37%);">
        <ChooseContact ref="contactModal" />
        <v-btn class="btn-left" color="transparent" @click="goClients">
          <v-icon dark large>
            mdi-account-outline
          </v-icon>
        </v-btn>
        <v-btn class="plus-btn" color="transparent" @click="showDialog">
          <v-icon class="plus-size">
            mdi-plus
          </v-icon>
        </v-btn>
        <v-dialog v-model="dialogVisible" transition="dialog-bottom-transition">
          <template v-slot:default="dialog">
            <v-card class="dialogpopup">
              <h3 class="title-center" style="color:rgba(255, 255, 255, 0.75) ">
                <br>{{ $t('What we do?') }}
              </h3>
              <v-card-text>
                <v-list color="primary" dark>
                  <v-list-item v-for="(opcions, index) in opcions" :key="index" @click="handleItemClick(opcions.title)">
                    <v-list-item-title>{{ opcions.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </template>
        </v-dialog>

        <v-btn class="settings-btn" color="transparent" @click="goSettings">
          <v-icon dark large>
            mdi-cog
          </v-icon>
        </v-btn>
      </v-footer>
    </div>
  </v-app>
</template>

<script>

import LocalRepository from "../repositories/LocalRepository";
import Loading from "../components/Loading";
import SplashScreen from "../components/SplashScreen";
import UserMissingCif from "../components/UserMissingCif";
import FactoringLogic from "../components/FactoringLogic";
import Constants from "../../constants";
import ConfirmationModal from "../components/ConfirmationModal";
import ApiRepository from "../repositories/ApiRepository";
import CameraModal from "components/CameraModal";
import notificationOptions from "../components/notificationOptions";
import SnackBar from "../components/SnackBar";
import PaymentModal from "components/PaymentModal";
import CollateralModal from "components/CollateralModal";
import InvoicesToMarketModal from "components/InvoicesToMarketModal";
import AmmModal from "components/AmmModal";
import ProfileAvatar from "../components/ProfileAvatar";
import ChooseContact from "../components/ChooseContact";
import NotificationBell from "vue-notification-bell";
export default {
    name: 'MainLayout',
    components: {
        ProfileAvatar,
        AmmModal,
        CollateralModal,
        // eslint-disable-next-line vue/no-unused-components
        PaymentModal, notificationOptions, ConfirmationModal, SplashScreen, FactoringLogic, Loading, UserMissingCif, CameraModal, SnackBar, InvoicesToMarketModal, ChooseContact,
        NotificationBell
    },
    data () {
        return {
            drawer: null,
            darkMode: false,
            tokenName: Constants.TOKEN_NAME,
            group: null,
            items: [
                { title: this.$t('Catalan') },
                { title: this.$t('Spanish') },
                { title: this.$t('English') },
            ],
            loading: false,
            fullscreen: false,
            fullscreenClass: "",
            fullscreenHide: "",
            showCookieConsent: false,
            hideOverlay: true,
            showFloadMenu: false,
            notifications: 0,
            dialogVisible: false,
            opcions: [
                { title: this.$t('Send') },
                { title: this.$t('Receive') },
                { title: this.$t('Exchange') },
            ],
        };
    },
    computed: {
        theme () {
            return (this.$vuetify.theme.dark) ? 'dark' : 'light';
        }
    },
    watch: {
        darkMode: function (newVal) {
            this.$vuetify.theme.dark = newVal;
            LocalRepository.set('dark', {dark: newVal});
            if (newVal) {
                document.body.classList.add("dark");
            } else {
                document.body.classList.remove("dark");
            }
        },
        $route () {
            this.refreshCookiePolicity();
        },
    },
    mounted () {
        this.$root.$on('ADD_NOTIFICATIONS', () => {
            this.fetch();
        });
        this.$ga.enable();
    },
    created () {
        if (this.$user) {
            this.$socket.emit('LOGIN', {id: this.$user._id});
        }
        const initialDark = LocalRepository.get('dark');
        if (initialDark) {
            this.$data.darkMode = initialDark.dark;
        }
        this.$root.$on('start-loading', () => {
            this.loading = true;
        });
        this.$root.$on('stop-loading', () => {
            this.loading = false;
        });

        this.$root.$on('fullscreen', () => {
            this.fullscreen = !this.fullscreen;
            if (this.fullscreen) {
                this.fullscreenClass = "full-screen";
                this.fullscreenHide = "full-screen-hide";
            } else {
                this.fullscreenClass = "";
                this.fullscreenHide = "";
            }
        });
        document.body.classList.remove("dark"); //desactivem dark mode que produeix la no visualització de moltes coses
        const showCookieConsent = localStorage.getItem('show-cookies-banner');
        if (showCookieConsent) {
            this.showCookieConsent = showCookieConsent !== "false";
        } else {
            this.showCookieConsent = true;
        }
        this.refreshCookiePolicity();
        this.fetch();
        /*setInterval(() => {
            this.fetch();
        }, 10000); //S'ha de mirar els sockets, no se que li passa*/
    },
    methods: {
        fetch () {
            this.notifications = 0;
            ApiRepository.getMyNotifications().then((res) => {
                const notifications = res.data.notifications;
                for (const notification in notifications) {
                    const found = notifications[notification].viewedBy.find(element => element === this.$user._id);
                    if (found === undefined) {
                        this.notifications++;
                    }
                }
            });
        },
        goUploadInvoice () {
            this.showFloadMenu = false;
            this.$router.push({name: 'imageInvoice', replace: true});
        },
        goMarketPlace () {
            this.showFloadMenu = false;
            this.$router.push({name: 'MarketPlace', replace: true});
        },
        goToCookiePolicity () {
            this.showFloadMenu = false;
            if (this.$router.history.current.name !== 'CookiePolicy') {
                this.$router.push({name: 'CookiePolicy', replace: true});
            }
        },
        refreshCookiePolicity () {
            this.showFloadMenu = false;
            this.hideOverlay = this.$router.history.current.name === 'CookiePolicy';
        },
        closeCookiesBanner () {
            localStorage.setItem('show-cookies-banner',  "false");
            this.showCookieConsent = false;
        },
        goLogin () {
            if (this.$router.history.current.name !== 'Login') {
                this.$router.push({name: 'Login', replace: true});
            }
        },
        goHome () {
            if (this.$router.history.current.name !== "InvoiceChats") {
                this.$router.push({name: 'InvoiceChats'});
            }
        },
        goProfile () {
            if (this.$router.history.current.name !== "profile") {
                this.$router.push({name: 'profile', replace: true});
            }
        },
        goPhotoInvoice () {
            if (this.$user) {
                if (this.$router.history.current.name !== "imageInvoice") {
                    this.$router.push({
                        name: 'imageInvoice',
                        params: {byppay: this.tab === 0 ? Constants.FORWARD_IDENTIFIER : Constants.BYPPAY_IDENTIFIER},
                        replace: true
                    });
                }
            } else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        userIsNotNormalUser () {
            return this.$user.role !== Constants.USER.ROLE_USER;
        },
        changeLanguage (lang) {
            let language = '';
            if (lang === 'Catalan' || lang === 'Català' || lang === 'Catalán') language = 'ca';
            if (lang === 'Spanish' || lang === 'Castellà' || lang === 'Español') language = 'es';
            if (lang === 'English' || lang === 'Anglès' || lang === 'Inglés') language = 'en';
            ApiRepository.changeLanguage(language)
                .then(() => {

                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error changing language'), color: 'error'});
                    console.error(err);
                });
            localStorage.setItem('language', language);
            location.reload();
        },
        privacyPolicy () {
            this.$router.push({name: 'PrivacyPolicy', replace: true});
        },
        goFaq () {
            if (this.$router.history.current.name !== "faq") {
                this.$router.push({name: 'faq', replace: true});
            }
        },
        goNotificationsPage () {
            if (this.$user) {
                if (this.$router.history.current.name !== "notifications") {
                    this.$router.push({name: 'Notifications', replace: true});
                }
            } else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        goClients () {
            if (this.$user)
                this.$router.push({name: 'clients', params: {}, replace: true});
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        goSettings () {
            if (this.$user)
                this.$router.push({name: 'Settings', params: {}, replace: true});
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        goExchange () {
            if (this.$user) {
                this.$router.push({name: 'Exchange', params: {}, replace: true});
            } else {
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
            }
        },
        addChatLeft () {
            if (this.$user)
                this.$refs.contactModal.openModal(Constants.CHAT_MODE.LEFT);
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        addChatRight () {
            if (this.$user)
                this.$refs.contactModal.openModal(Constants.CHAT_MODE.RIGHT);
            else
                this.$root.$emit('show-snackbar', {message: this.$t('InvoiceChats.registeredError'), color: "error"});
        },
        showDialog () {
            this.dialogVisible = true;
        },
        handleItemClick (item) {
            if (item === 'Exchange' || item === 'Cambio de divisas' || item === 'Canvi de divises') this.goExchange();
            if (item === 'Pagar factura' || item === 'Pay invoice') this.addChatRight();
            if (item === 'Cobrar factura' || item === 'Receive payment') this.addChatLeft();
            console.log(item);
            this.dialogVisible = false;
        },
    },
    sockets: {
        CONNECTION_SOCKET (socket) {
            LocalRepository.set('connectionSocket', socket);
        },
        ADD_NOTIFICATIONS () {
            console.log("ADD");
            function beep () {
                const snd = new Audio("Client/public/ding.mp3");
                snd.play();
            }
            beep();
            this.fetch();

        },
        REMOVE_NOTIFICATIONS () {
            console.log("REMOVE");
            this.notifications = 0;
            this.fetch();
        }
    },
};
</script>

<style scoped>

.plus-size {
  font-size: 40px;
}


.icon-menu {
    background: #61a9d1;
    margin-right: 10px;
    padding: 8px 8px 8px 7px;
    border-radius: 50%;
  }
.footer{
  position: fixed;
  bottom : 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f2f2f2;
  max-width: 600px;
  margin: auto;
}

  .app-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

.plus-btn{
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  box-shadow: none;
}


.btn-left{
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  box-shadow: none;
}

  .dialogpopup{
    position: absolute;
    margin: auto;
    border-top-left-radius: 70px;
    border-top-right-radius: 70px;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 600px;
    height: 40%;
    text-align: center;
    background: rgba(67, 225, 178, 0.95);
  }

.settings-btn{
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  box-shadow: none;
}
.buttonMenu{
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
}
.fas.fa-file-invoice {
    margin-left: 3px;
    margin-right: 6px;
}
.fas.fa-file-signature {
    margin-left: 3px;
    margin-right: -3px;
}
/*Cookie Consent Begin*/
#cookieConsent {
    background-color: rgba(20,20,20,0.8);
    min-height: 26px;
    font-size: 14px;
    color: #ccc;
    line-height: 26px;
    padding: 8px 30px 8px 30px;
    font-family: "Trebuchet MS",Helvetica,sans-serif;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    z-index: 9999;
}
#cookieConsent a {
    color: #4B8EE7;
    text-decoration: none;
}
#closeCookieConsent {
    float: right;
    display: inline-block;
    cursor: pointer;
    height: 20px;
    width: 20px;
    margin: -15px 0 0 0;
    font-weight: bold;
}
#closeCookieConsent:hover {
    color: #FFF;
}
#cookieConsent a.cookieConsentOK {
    background-color: #F1D600;
    color: #000;
    display: inline-block;
    border-radius: 5px;
    padding: 0 20px;
    cursor: pointer;
    float: right;
    margin: 0 60px 0 10px;
}
#cookieConsent a.cookieConsentOK:hover {
    background-color: #E0C91F;
}
/*Cookie Consent End*/
.v-input--selection-controls {
    padding-top: 0px;
  }
  body {
    min-height: 100vh;
    padding-bottom: 10px;
    width: 100%;
    position: absolute;
  }
</style>
<style>
.buttonMenu i{
    font-size: 80px !important;
    color: #00E3B4 !important;
}
.v-application--wrap{
    display: contents;
}
.v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

}
body.dark {
    background: #2f2f2f;
}
.width-max-content {
    max-width: max-content;
}

  .fill-height {
    height: 100%;
}

.overflow-y {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.full-screen{
    top: 0 !important;
    bottom: 0 !important;
}
.full-screen-hide{
    display: none;
  }
  .custom-switch .v-input--selection-controls__input div{
   color: var(--v-switch-base) !important;
  }

html,body {
    margin:    0 auto;
    max-width: 600px;
    height: 100%;
    overscroll-behavior-y: none;
    overflow-y: hidden;
  }


.slide-fade-enter-active {
    transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
}

.listItem, .listItem i{
    color: white !important;
}
.cardStyle{
    border-radius: 25px !important;
    border: 4px solid #000000 !important;
}
.titleCard{
    color: var(--v-btnSucces-base) !important;
    text-align: left
}
.btnYes{
    margin: auto;
    padding: 15px 75px;
    color: white !important;
    background-color: var(--v-btnSucces-base) !important;
}
.btnNo{
    margin: auto;
    padding: 15px 75px;
    color: white !important;
    background-color: var(--v-btnNo-base) !important;
}
.v-app-bar{
    /*background: rgb(78,246,162);*/
    /*background: linear-gradient(151deg, rgba(78,246,162,1) 0%, rgba(0,235,181,1) 11%, rgba(47,187,244,1) 47%);*/
}
.palabra {
    width: 15%;
    margin-left: 5px;
    margin-right: 6%;
  }

</style>
